// extracted by mini-css-extract-plugin
export default {"defaultButton":"Button_defaultButton__27cbP","blackButton":"Button_blackButton__To1RE","blueButton":"Button_blueButton__plS4F","orangeButton":"Button_orangeButton__KVWLQ"};